import Home from './components/Home';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Home />
      <Footer />
    </>
  );
}

export default App;